var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var AccountKeyIcon = function () {
    return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M11 10V12H9V14H7V12H5.8C5.4 13.2 4.3 14 3 14C1.3 14 0 12.7 0 11C0 9.3 1.3 8 3 8C4.3 8 5.4 8.8 5.8 10H11ZM3 10C2.4 10 2 10.4 2 11C2 11.6 2.4 12 3 12C3.6 12 4 11.6 4 11C4 10.4 3.6 10 3 10ZM16 14C18.7 14 24 15.3 24 18V20H8V18C8 15.3 13.3 14 16 14ZM16 12C13.8 12 12 10.2 12 8C12 5.8 13.8 4 16 4C18.2 4 20 5.8 20 8C20 10.2 18.2 12 16 12Z", fill: "#6B7280" }) })));
};
